module.exports = __webpack_public_path__ + "static/img/103012.5f7e9899.png";